/**
 * Shared stock-status / financial-year rules (moved here from stockFlowHelper
 * so the costing engine can use them without a circular import —
 * stockFlowHelper re-exports all three, so every existing import still works).
 */

// All statuses that count as "active" for stock calculations
// Exported so every stock reader (incl. the POS item-card badge) counts the
// SAME statuses — otherwise the POS would silently miss GRN receipts ('Received'),
// Paid/Partial sale invoices and delivered DCs, and disagree with Inventory Balances.
// 'Invoiced' MUST be here: in DC-out (challan) and GRN-in modes the DC/GRN is the
// stock-posting document, and once its next doc is created it flips to 'Invoiced'
// (updateTransactionStatus rewrites its stockFlow rows to match). Without 'Invoiced'
// those rows stop counting and the posted movement silently disappears.
// INV-01 fix (2026-09-30): 'Sent' = Send Inventory OUT leg (source branch). It was
// missing, so sending never reduced the source branch and stock was counted twice.
export const ACTIVE_STOCK_STATUSES = ['Posted', 'Received', 'Dispatched', 'Delivered', 'Invoiced', 'Completed', 'InProgress', 'Partial', 'Paid', 'Sent', 'Partially Received'];

/**
 * ── FINANCIAL-YEAR SCOPE (critical) ──
 * Opening balances are entered PER financial year, and a new year's opening stock
 * already contains the previous year's closing. So "current stock" must only count
 * the ACTIVE year's rows — otherwise it adds BOTH years' opening stock together and
 * shows exactly double (e.g. 96 becomes 192).
 *
 * Filtered in JS rather than as a Firestore `where` clause on purpose: these queries
 * already carry equality filters, and adding another would force new composite
 * indexes. Falls back to "count everything" when no active year is set, so nothing
 * changes for a company with a single financial year.
 */
export const activeFyId = () =>
  (typeof window !== 'undefined' && window.__AMAL_ACTIVE_FY_ID__) || null;

export const inActiveFy = (row, fyId = activeFyId()) => {
  if (!fyId) return true;                 // no active year known → old behaviour
  if (!row.financialYearId) return true;  // legacy row with no year → keep counting it
  return row.financialYearId === fyId;
};
